/*
 * @Author: zhechuan.Wang
 * @Date: 2023-12-07 14:43:32
 * @LastEditors: zhechuan.Wang
 * @LastEditTime: 2023-12-08 09:47:48
 * @Description: 树接口
 * @FilePath: \gfmis-card-ppt\src\api\cardTree.js
 */
import axiosApi from './AxiosApi.js';

const [methodGet, methodPost, methodPut, methodDelete] = ['GET', 'POST', 'PUT', 'DELETE'];

export default {
  getCardReqInfoDetail(data) {
    return axiosApi({
      method: methodPost,
      url: `/anno/cardReq/getCardReqInfoDetail`,
      data,
    });
  },
  getCardReqPage(data) {
    return axiosApi({
      method: methodPost,
      url: `/anno/cardReq/getCardReqPage`,
      data,
    });
  },
  // 获取访问次数
  getOnlineCount(data) {
    return axiosApi({
      method: methodGet,
      url: `/anno/view`,
      data,
    });
  },
};
